import React, { useEffect, useState } from 'react';
import { useMount } from 'ahooks';
import { useSelector } from 'react-redux';
import Loading from 'components/loading/Loading';
import { Button, Col, InputGroup, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

import { todayFormatted } from 'helpers.js';
import { step1, step2 } from './functions';

export default () => {
  const { caricamentoInCorso, categorie, fornitori, metodiPagamento } = useSelector((state) => state.notaSpese);
  const [tr, setTr] = useState('T');
  // const [inizio, setInizio] = useState();
  // const [fine, setFine] = useState();
  const [km, setKm] = useState(0);
  const [note, setNote] = useState('');
  const [categoria, setCategoria] = useState('');
  const [fornitore, setFornitore] = useState({ codice: '', nome: '' });
  const [pagamento, setPagamento] = useState('');
  const [carta, setCarta] = useState(0);
  const [prezzo, setPrezzo] = useState(0.0);
  const [immagine, setImmagine] = useState(undefined);
  const [esenzioneImmagine, setEsenzioneImmagine] = useState(false);

  const reset = () => {
    setCategoria('');
    setFornitore({ codice: '', nome: '' });
    setPagamento('');
    setCarta(0);
    setPrezzo(0);
    setImmagine(undefined);
  };

  useMount(step1);

  useEffect(() => {
    if (categoria === 'RIMBORSO KM') {
      setEsenzioneImmagine(true);
    } else {
      setEsenzioneImmagine(false);
    }
  }, [categoria]);

  if (caricamentoInCorso) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <section className="mb-3">
          <h4>Scegli una categoria</h4>
          <Row>
            <Col>
              <Form.Select value={tr} onChange={(e) => setTr(e.target.value)}>
                <option value="T">Trasferta</option>
                <option value="R">Rappresentanza</option>
              </Form.Select>
            </Col>
            <Col>
              <Form.Select value={categoria} onChange={(e) => setCategoria(e.target.value)}>
                <option disabled selected value="">
                  Scegli una categoria
                </option>
                {categorie.map((c) => {
                  return (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  );
                })}
              </Form.Select>
            </Col>
          </Row>
        </section>

        {/*         <section className="mb-3">
          <Row>
            <Col>
              <h4>Inizio</h4>
              <Form.Control placeholder="Inserisci la data di inizio" className="mt-3" type="date" value={inizio} onChange={(e) => setInizio(e.target.value)} />
            </Col>
            <Col>
              <h4>Fine</h4>
              <Form.Control placeholder="Inserisci la data di fine" className="mt-3" type="date" value={fine} onChange={(e) => setFine(e.target.value)} />
            </Col>
          </Row>
        </section> */}
        {categoria && (
          <section className="mb-3">
            <h4>Scegli un fornitore</h4>
            <Form.Select
              value={fornitore?.codice}
              onChange={(e) => {
                if (Number(e.target.value) === 0) return setFornitore({ codice: 0, nome: '' });
                const { Codice: codice, RagSociale: nome } = fornitori[categoria]?.find((a) => a?.Codice === e.target.value);
                return setFornitore({ codice, nome });
              }}
            >
              <option disabled selected value="">
                Scegli un fornitore
              </option>
              {fornitori[categoria]?.map((c) => {
                return (
                  <option key={c?.Codice} value={c?.Codice}>
                    {c?.RagSociale}
                  </option>
                );
              })}
              <option value={0}>Fornitore personalizzato</option>
            </Form.Select>

            {fornitore.codice === 0 && (
              <Form.Control
                placeholder="Inserisci la ragione sociale"
                className="mt-3"
                type="text"
                value={fornitore?.nome}
                onChange={(e) => setFornitore({ codice: 0, nome: e.target.value })}
              />
            )}
          </section>
        )}

        {fornitore?.nome && (
          <>
            <section className="mb-3">
              <h4>Descrivi il pagamento</h4>
              <Row>
                <Col>
                  <Form.Select
                    value={pagamento}
                    onChange={(e) => {
                      setPagamento(e.target.value);
                    }}
                  >
                    <option disabled selected value="">
                      Scegli la tipologia di pagamento
                    </option>
                    <option>Fattura</option>
                    <option>Ricevuta Fiscale</option>
                    <option>Scontrino</option>
                  </Form.Select>
                </Col>

                <Col>
                  <Form.Select
                    value={carta}
                    onChange={(e) => {
                      setCarta(e.target.value);
                    }}
                  >
                    <option disabled selected value="">
                      Scegli un metodo di pagamento
                    </option>
                    {metodiPagamento?.map((c) => {
                      return (
                        <option key={c?.Pagamento} value={c?.IdPagamento}>
                          {c?.Pagamento}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Row>
                <Col>
                  <InputGroup className="mt-3">
                    <InputGroup.Text id="basic-addon1">€</InputGroup.Text>
                    <Form.Control
                      placeholder="Costo sostenuto"
                      value={prezzo}
                      onChange={(e) => setPrezzo(e.target.value)}
                      type="number"
                      step="0.01"
                      min="0"
                      aria-label="Costo sostenuto"
                      aria-describedby="basic-addon1"
                    />
                  </InputGroup>
                </Col>
                <Col>
                  <InputGroup className="mt-3">
                    <InputGroup.Text id="basic-addon2">KM</InputGroup.Text>
                    <Form.Control
                      placeholder="Km totali"
                      value={km}
                      onChange={(e) => setKm(e.target.value)}
                      type="number"
                      step="0.01"
                      min="0"
                      aria-label="KM Totali"
                      aria-describedby="basic-addon2"
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Form.Control placeholder="Note" value={note} onChange={(e) => setNote(e.target.value)} type="text" />
                </Col>
              </Row>
            </section>

            {!esenzioneImmagine && (
              <section className="mb-3">
                <h4>Carica una foto della ricevuta/fattura</h4>
                <Form.Control type="file" capture="environment" accept="image/*" onChange={(e) => setImmagine(e.target.files[0])} />
              </section>
            )}

            {(esenzioneImmagine || immagine) && (
              <section>
                <Button
                  onClick={() => {
                    step2(
                      {
                        tipologia: pagamento,
                        fornitore: fornitore?.codice ?? 0,
                        fornitore_nome: fornitore.nome,
                        pagamento: carta,
                        costo: Number(prezzo).toString().replace('.', ','),
                        km,
                        note,
                        start: todayFormatted(),
                        end: todayFormatted(),
                        tipo: tr,
                      },
                      immagine,
                      reset
                    );
                  }}
                >
                  Salva nota spesa
                </Button>
              </section>
            )}
          </>
        )}
      </Col>
    </Row>
  );
};
